(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["flexi-equalize"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.FlexiEqualize) return;

  function equalize(root) {
    if (!root) return;
    root.style.removeProperty('--flexi-card-min-height');
    var cards = root.querySelectorAll('.flexi-equal-card');
    if (!cards.length) return;
    var max = 0;
    cards.forEach(function (card) {
      max = Math.max(max, card.offsetHeight);
    });
    if (max > 0) root.style.setProperty('--flexi-card-min-height', max + 'px');
  }

  window.FlexiEqualize = equalize;

  function bind(root) {
    if (!root || root._flexiEqualBound) return;
    root._flexiEqualBound = true;
    var timer = null;
    if (window.ResizeObserver) {
      new ResizeObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(function () { equalize(root); }, 200);
      }).observe(root);
    }
    equalize(root);
  }

  function rootsIn(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var nodes = [];
    if (root.matches && root.matches('[data-flexi-equalize]')) nodes.push(root);
    root.querySelectorAll('[data-flexi-equalize]').forEach(function (node) {
      nodes.push(node);
    });
    return nodes;
  }

  function scan(scope) {
    rootsIn(scope).forEach(bind);
  }

  function start() { scan(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  document.addEventListener('shopify:section:reorder', function (event) { scan(event.target); });
  document.addEventListener('shopify:block:select', function (event) { scan(event.target); });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["flexi-featured-images"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.FlexiFeaturedImages) return;
  window.FlexiFeaturedImages = true;

  function init(root) {
    if (!root || root._flexiFeatured) return;
    root._flexiFeatured = true;
    var images = root.querySelectorAll('.flexi-featured-img, .flexi-featured-placeholder-img');
    if (!images.length) return;
    var currentIndex = 0;
    images[0].style.display = 'block';
    if (images.length < 2) return;

    window.setInterval(function () {
      if (!root.isConnected) return;
      images[currentIndex].style.display = 'none';
      images[currentIndex].classList.remove('flexi-featured-image-fade');
      currentIndex = (currentIndex + 1) % images.length;
      images[currentIndex].style.display = 'block';
      images[currentIndex].classList.add('flexi-featured-image-fade');
      var loadingBar = root.querySelector('.flexi-loading-bar');
      if (loadingBar) {
        loadingBar.style.animation = 'none';
        void loadingBar.offsetHeight;
        loadingBar.style.animation = '';
      }
    }, 3000);
  }

  function scan(scope) {
    (scope || document).querySelectorAll('[data-flexi-featured-images]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); });
  } else {
    scan(document);
  }
  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["flexi-product-layout"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      connectedCallback() {
        if (this.dataset.flexiBound === 'true') return;
        this.form = this.querySelector('form');
        this.submitButton = this.querySelector('[type="submit"]');
        if (!this.form || !this.submitButton) return;
        this.dataset.flexiBound = 'true';
        this.variantIdInput = this.form.querySelector('[name="id"]');
        this.spinner = this.querySelector('.flexi-loading-spinner');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (this.variantIdInput) this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }

      onSubmitHandler(event) {
        event.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        this.toggleLoadingState(true);
        var formData = new FormData(this.form);
        if (this.cart && this.cart.getSectionsToRender) {
          formData.append('sections', this.cart.getSectionsToRender().map(function (section) { return section.id; }));
          formData.append('sections_url', window.location.pathname);
          if (this.cart.setActiveElement) this.cart.setActiveElement(document.activeElement);
        }
        var self = this;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        })
          .then(function (response) { return response.json(); })
          .then(function (data) {
            if (data.status) {
              self.handleErrorMessage(data.description || 'An error occurred.');
              return;
            }
            if (self.cart && self.cart.renderContents) {
              self.cart.renderContents(data);
              if (self.cart.tagName.toLowerCase() === 'cart-drawer') self.cart.classList.add('is-open');
            } else {
              window.location = '/cart';
            }
          })
          .catch(function (error) { console.error(error); })
          .finally(function () { self.toggleLoadingState(false); });
      }

      toggleLoadingState(isLoading) {
        var content = this.submitButton.querySelector('.flexi-atc-content');
        if (isLoading) {
          this.submitButton.setAttribute('aria-disabled', 'true');
          this.submitButton.classList.add('loading');
          if (this.spinner) this.spinner.classList.add('visible');
          if (content) content.hidden = true;
        } else {
          this.submitButton.removeAttribute('aria-disabled');
          this.submitButton.classList.remove('loading');
          if (this.spinner) this.spinner.classList.remove('visible');
          if (content) content.hidden = false;
        }
      }

      handleErrorMessage(errorMessage) {
        var wrapper = this.querySelector('.product-form__error-message-wrapper');
        var element = this.querySelector('.product-form__error-message');
        if (!wrapper || !element) return;
        wrapper.hidden = !errorMessage;
        element.textContent = errorMessage || '';
      }
    }
  );
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["flexi-slider"] && !Shopify.designMode) return;
  try {
    var BlazeSlider = (function () {
    "use strict";
    const t = "start";
    function e(t, e, n) {
        (t.stateIndex = 0),
            (function (t) {
                const { slidesToScroll: e, slidesToShow: n } = t.config,
                    { totalSlides: i, config: s } = t;
                if ((i < n && (s.slidesToShow = i), !(i <= n) && (e > n && (s.slidesToScroll = n), i < e + n))) {
                    const t = i - n;
                    s.slidesToScroll = t;
                }
            })(t),
            (t.isStatic = e <= n.slidesToShow),
            (t.states = (function (t) {
                const { totalSlides: e } = t,
                    { loop: n } = t.config,
                    i = (function (t) {
                        const { slidesToShow: e, slidesToScroll: n, loop: i } = t.config,
                            { isStatic: s, totalSlides: o } = t,
                            r = [],
                            a = o - 1;
                        for (let t = 0; t < o; t += n) {
                            const n = t + e - 1;
                            if (n > a) {
                                if (!i) {
                                    const t = a - e + 1,
                                        n = r.length - 1;
                                    (0 === r.length || (r.length > 0 && r[n][0] !== t)) && r.push([t, a]);
                                    break;
                                }
                                {
                                    const e = n - o;
                                    r.push([t, e]);
                                }
                            } else r.push([t, n]);
                            if (s) break;
                        }
                        return r;
                    })(t),
                    s = [],
                    o = i.length - 1;
                for (let t = 0; t < i.length; t++) {
                    let r, a;
                    n
                        ? ((r = t === o ? 0 : t + 1), (a = 0 === t ? o : t - 1))
                        : ((r = t === o ? o : t + 1), (a = 0 === t ? 0 : t - 1));
                    const l = i[t][0],
                        c = i[r][0],
                        d = i[a][0];
                    let u = c - l;
                    c < l && (u += e);
                    let f = l - d;
                    d > l && (f += e),
                        s.push({
                            page: i[t],
                            next: { stateIndex: r, moveSlides: u },
                            prev: { stateIndex: a, moveSlides: f },
                        });
                }
                return s;
            })(t));
    }
    function n(t) {
        if (t.onSlideCbs) {
            const e = t.states[t.stateIndex],
                [n, i] = e.page;
            t.onSlideCbs.forEach((e) => e(t.stateIndex, n, i));
        }
    }
    function i(t) {
        (t.offset = -1 * t.states[t.stateIndex].page[0]), s(t), n(t);
    }
    function s(t) {
        const { track: e, offset: n, dragged: i } = t;
        e.style.transform =
            0 === n
                ? `translate3d(${i}px,0px,0px)`
                : `translate3d(  calc( ${i}px + ${n} * (var(--slide-width) + ${t.config.slideGap})),0px,0px)`;
    }
    function o(t) {
        t.track.style.transitionDuration = `${t.config.transitionDuration}ms`;
    }
    function r(t) {
        t.track.style.transitionDuration = "0ms";
    }
    const a = () => "ontouchstart" in window;
    function l(t) {
        const e = this,
            n = e.slider;
        if (!n.isTransitioning) {
            if (
                ((n.dragged = 0),
                (e.isScrolled = !1),
                (e.startMouseClientX = "touches" in t ? t.touches[0].clientX : t.clientX),
                !("touches" in t))
            ) {
                (t.target || e).setPointerCapture(t.pointerId);
            }
            r(n), f(e, "addEventListener");
        }
    }
    function c(t) {
        const e = this,
            n = "touches" in t ? t.touches[0].clientX : t.clientX,
            i = (e.slider.dragged = n - e.startMouseClientX),
            o = Math.abs(i);
        o > 5 && (e.slider.isDragging = !0),
            o > 15 && t.preventDefault(),
            (e.slider.dragged = i),
            s(e.slider),
            !e.isScrolled && e.slider.config.loop && i > 10 && ((e.isScrolled = !0), e.slider.prev());
    }
    function d() {
        const t = this,
            e = t.slider.dragged;
        (t.slider.isDragging = !1),
            f(t, "removeEventListener"),
            (t.slider.dragged = 0),
            s(t.slider),
            o(t.slider),
            t.isScrolled || (e < -10 ? t.slider.next() : e > 10 && t.slider.prev());
    }
    const u = (t) => t.preventDefault();
    function f(t, e) {
        t[e]("contextmenu", d),
            a() ? (t[e]("touchend", d), t[e]("touchmove", c)) : (t[e]("pointerup", d), t[e]("pointermove", c));
    }
    const h = {
        slideGap: "20px",
        slidesToScroll: 1,
        slidesToShow: 1,
        loop: !0,
        enableAutoplay: !1,
        stopAutoplayOnInteraction: !0,
        autoplayInterval: 3e3,
        autoplayDirection: "to left",
        enablePagination: !0,
        transitionDuration: 300,
        transitionTimingFunction: "ease",
        draggable: !0,
    };
    function g(t) {
        const e = { ...h };
        for (const n in t)
            if (window.matchMedia(n).matches) {
                const i = t[n];
                for (const t in i) e[t] = i[t];
            }
        return e;
    }
    function p() {
        const t = this.index,
            e = this.slider,
            n = e.stateIndex,
            i = e.config.loop,
            s = Math.abs(t - n),
            o = e.states.length - s,
            r = s > e.states.length / 2 && i;
        t > n ? (r ? e.prev(o) : e.next(s)) : r ? e.next(o) : e.prev(s);
    }
    function v(t, e = t.config.transitionDuration) {
        (t.isTransitioning = !0),
            setTimeout(() => {
                t.isTransitioning = !1;
            }, e);
    }
    function S(e, n) {
        const i = e.el.classList,
            s = e.stateIndex,
            o = e.paginationButtons;
        e.config.loop || (0 === s ? i.add(t) : i.remove(t), s === e.states.length - 1 ? i.add("end") : i.remove("end")),
            o && e.config.enablePagination && (o[n].classList.remove("active"), o[s].classList.add("active"));
    }
    function m(n, i) {
        const o = i.track;
        (i.slides = o.children),
            (i.offset = 0),
            (i.config = n),
            e(i, i.totalSlides, n),
            n.loop || i.el.classList.add(t),
            n.enableAutoplay && !n.loop && (n.enableAutoplay = !1),
            (o.style.transitionProperty = "transform"),
            (o.style.transitionTimingFunction = i.config.transitionTimingFunction),
            (o.style.transitionDuration = `${i.config.transitionDuration}ms`);
        const { slidesToShow: r, slideGap: c } = i.config;
        i.el.style.setProperty("--slides-to-show", r + ""),
            i.el.style.setProperty("--slide-gap", c),
            i.isStatic
                ? i.el.classList.add("static")
                : n.draggable &&
                  (function (t) {
                      const e = t.track;
                      e.slider = t;
                      const n = a() ? "touchstart" : "pointerdown";
                      e.addEventListener(n, l),
                          e.addEventListener("click", (e) => {
                              (t.isTransitioning || t.isDragging) && e.preventDefault();
                          }),
                          e.addEventListener("dragstart", u);
                  })(i),
            (function (t) {
                if (!t.config.enablePagination || t.isStatic) return;
                const e = t.el.querySelector(".blaze-pagination");
                if (!e) return;
                t.paginationButtons = [];
                const n = t.states.length;
                for (let i = 0; i < n; i++) {
                    const s = document.createElement("button");
                    t.paginationButtons.push(s),
                        (s.textContent = 1 + i + ""),
                        (s.ariaLabel = `${i + 1} of ${n}`),
                        e.append(s),
                        (s.slider = t),
                        (s.index = i),
                        (s.onclick = p);
                }
                t.paginationButtons[0].classList.add("active");
            })(i),
            (function (t) {
                const e = t.config;
                if (!e.enableAutoplay) return;
                const n = "to left" === e.autoplayDirection ? "next" : "prev";
                (t.autoplayTimer = setInterval(() => {
                    t[n]();
                }, e.autoplayInterval)),
                    e.stopAutoplayOnInteraction &&
                        t.el.addEventListener(
                            a() ? "touchstart" : "mousedown",
                            () => {
                                clearInterval(t.autoplayTimer);
                            },
                            { once: !0 }
                        );
            })(i),
            (function (t) {
                const e = t.el.querySelector(".blaze-prev"),
                    n = t.el.querySelector(".blaze-next");
                e &&
                    (e.onclick = () => {
                        t.prev();
                    }),
                    n &&
                        (n.onclick = () => {
                            t.next();
                        });
            })(i),
            s(i);
    }
    return class extends class {
        constructor(t, n) {
            (this.config = n), (this.totalSlides = t), (this.isTransitioning = !1), e(this, t, n);
        }
        next(t = 1) {
            if (this.isTransitioning || this.isStatic) return;
            const { stateIndex: e } = this;
            let n = 0,
                i = e;
            for (let e = 0; e < t; e++) {
                const t = this.states[i];
                (n += t.next.moveSlides), (i = t.next.stateIndex);
            }
            return i !== e ? ((this.stateIndex = i), [e, n]) : void 0;
        }
        prev(t = 1) {
            if (this.isTransitioning || this.isStatic) return;
            const { stateIndex: e } = this;
            let n = 0,
                i = e;
            for (let e = 0; e < t; e++) {
                const t = this.states[i];
                (n += t.prev.moveSlides), (i = t.prev.stateIndex);
            }
            return i !== e ? ((this.stateIndex = i), [e, n]) : void 0;
        }
    } {
        constructor(t, e) {
            const n = t.querySelector(".blaze-track"),
                i = n.children,
                s = e ? g(e) : { ...h };
            super(i.length, s),
                (this.config = s),
                (this.el = t),
                (this.track = n),
                (this.slides = i),
                (this.offset = 0),
                (this.dragged = 0),
                (this.isDragging = !1),
                (this.el.blazeSlider = this),
                (this.passedConfig = e);
            (n.slider = this), m(s, this);
        }
        next(t) {
            if (this.isTransitioning) return;
            const e = super.next(t);
            if (!e) return;
            const [a, l] = e;
            S(this, a),
                v(this),
                (function (t, e) {
                    const a = requestAnimationFrame;
                    t.config.loop
                        ? ((t.offset = -1 * e),
                          s(t),
                          setTimeout(() => {
                              !(function (t, e) {
                                  for (let n = 0; n < e; n++) t.track.append(t.slides[0]);
                              })(t, e),
                                  r(t),
                                  (t.offset = 0),
                                  s(t),
                                  a(() => {
                                      a(() => {
                                          o(t), n(t);
                                      });
                                  });
                          }, t.config.transitionDuration))
                        : i(t);
                })(this, l);
        }
        prev(t) {
            if (this.isTransitioning) return;
            const e = super.prev(t);
            if (!e) return;
            const [l, c] = e;
            S(this, l),
                v(this),
                (function (t, e) {
                    const l = requestAnimationFrame;
                    if (t.config.loop) {
                        r(t),
                            (t.offset = -1 * e),
                            s(t),
                            (function (t, e) {
                                const n = t.slides.length;
                                for (let i = 0; i < e; i++) {
                                    const e = t.slides[n - 1];
                                    t.track.prepend(e);
                                }
                            })(t, e);
                        const i = () => {
                            l(() => {
                                o(t),
                                    l(() => {
                                        (t.offset = 0), s(t), n(t);
                                    });
                            });
                        };
                        t.isDragging
                            ? a()
                                ? t.track.addEventListener("touchend", i, { once: !0 })
                                : t.track.addEventListener("pointerup", i, { once: !0 })
                            : l(i);
                    } else i(t);
                })(this, c);
        }
        stopAutoplay() {
            clearInterval(this.autoplayTimer);
        }
        destroy() {
            this.track.removeEventListener(a() ? "touchstart" : "pointerdown", l),
                this.stopAutoplay(),
                this.paginationButtons?.forEach((t) => t.remove()),
                this.el.classList.remove("static"),
                this.el.classList.remove(t);
        }
        refresh() {
            const t = this.passedConfig ? g(this.passedConfig) : { ...h };
            this.destroy(), m(t, this);
        }
        onSlide(t) {
            return (
                this.onSlideCbs || (this.onSlideCbs = new Set()),
                this.onSlideCbs.add(t),
                () => this.onSlideCbs.delete(t)
            );
        }
    };
})();


(function () {
  if (window.FlexiSliderEngine) return;
  window.FlexiSliderEngine = true;

  function breakpoint() {
    var w = window.innerWidth;
    if (w <= 500) return 'mobile';
    if (w < 901) return 'tablet';
    return 'desktop';
  }

  function config(el) {
    var tabletMax = parseInt(el.getAttribute('data-tablet-max'), 10) || 900;
    var mobileMax = parseInt(el.dataset.mobileMax, 10) || 500;
    var conf = {
      all: {
        slidesToShow: parseFloat(el.dataset.desktop) || 4,
        slidesToScroll: 1,
        transitionDuration: 200,
        loop: el.dataset.loop === 'true',
        draggable: el.dataset.draggable !== 'false',
        autoplayInterval: parseFloat(el.dataset.duration) || 2000,
        enableAutoplay: el.dataset.autoplay === 'true',
        stopAutoplayOnInteraction: el.dataset.pause === 'true',
        enablePagination: (el.dataset.pagination || 'dots') === 'dots'
      }
    };
    conf['(max-width: ' + tabletMax + 'px)'] = {
      slidesToShow: parseFloat(el.dataset.tablet) || 2.2
    };
    conf['(max-width: ' + mobileMax + 'px)'] = {
      slidesToShow: parseFloat(el.dataset.mobile) || 1.2
    };
    return conf;
  }

  function equalize(root) {
    if (window.FlexiEqualize) window.FlexiEqualize(root);
  }

  function reveal(el) {
    var dots = el.querySelector('.blaze-pagination');
    if (!dots) return;
    dots.classList.remove('u-opacity-0');
    dots.classList.add('u-opacity-100');
  }

  function destroy(el) {
    if (!el) return;
    if (typeof el._flexiScrollbarCleanup === 'function') el._flexiScrollbarCleanup();
    delete el._flexiScrollbarCleanup;
    if (el._flexiScrollbarObserver) {
      el._flexiScrollbarObserver.disconnect();
      delete el._flexiScrollbarObserver;
    }
    if (el._flexiBlaze && el._flexiBlaze.destroy) el._flexiBlaze.destroy();
    delete el._flexiBlaze;
    delete el._flexiScrollbarReady;
    var dots = el.querySelector('.blaze-pagination');
    if (dots) dots.innerHTML = '';
  }

  function setupScrollbar(el, slider) {
    var paginationEl = el.querySelector('.blaze-pagination--scrollbar');
    if (!paginationEl || !slider) return;
    var trackEl = paginationEl.querySelector('.blaze-scrollbar-track');
    var fillEl = paginationEl.querySelector('.blaze-scrollbar-fill');
    var blazeTrack = el.querySelector('.blaze-track');
    if (!trackEl || !fillEl || !blazeTrack) return;

    var hideTimer = null;
    var showScrollbar = function () {
      paginationEl.classList.add('blaze-scrollbar-visible');
      if (hideTimer) clearTimeout(hideTimer);
      hideTimer = setTimeout(function () {
        paginationEl.classList.remove('blaze-scrollbar-visible');
        hideTimer = null;
      }, 1000);
    };

    var updateScrollbar = function (percent) {
      fillEl.style.width = Math.max(0, Math.min(100, percent)) + '%';
    };

    var updateFromState = function () {
      var numStates = (slider.states && slider.states.length) || 1;
      paginationEl.style.display = numStates <= 1 ? 'none' : '';
      if (numStates <= 1) return;
      var idx = slider.stateIndex || 0;
      updateScrollbar((idx / (numStates - 1)) * 100);
    };

    if (slider.onSlide) slider.onSlide(updateFromState);
    updateFromState();

    var container = el.querySelector('.blaze-container');
    if (container) {
      container.addEventListener('pointerdown', showScrollbar);
      container.addEventListener('touchstart', showScrollbar);
    }

    trackEl.addEventListener('click', function (event) {
      var rect = trackEl.getBoundingClientRect();
      var percent = ((event.clientX - rect.left) / rect.width) * 100;
      var numStates = (slider.states && slider.states.length) || 1;
      if (numStates <= 1) return;
      var targetIdx = Math.round((percent / 100) * (numStates - 1));
      var steps = targetIdx - (slider.stateIndex || 0);
      if (steps > 0 && slider.next) slider.next(steps);
      else if (steps < 0 && slider.prev) slider.prev(-steps);
    });

    var obs = new MutationObserver(function () {
      showScrollbar();
      requestAnimationFrame(function () {
        var wrapper = blazeTrack.closest('.blaze-track-wrapper') || blazeTrack.parentElement;
        if (!wrapper) return;
        var wr = wrapper.getBoundingClientRect();
        var tr = blazeTrack.getBoundingClientRect();
        var maxScroll = Math.max(0, tr.width - wr.width);
        if (maxScroll <= 0) return;
        updateScrollbar(Math.max(0, Math.min(1, (wr.left - tr.left) / maxScroll)) * 100);
      });
    });
    obs.observe(blazeTrack, { attributes: true, attributeFilter: ['style'] });
    el._flexiScrollbarObserver = obs;
    el._flexiScrollbarCleanup = function () {
      if (hideTimer) clearTimeout(hideTimer);
      if (container) {
        container.removeEventListener('pointerdown', showScrollbar);
        container.removeEventListener('touchstart', showScrollbar);
      }
    };
  }

  function liftTrackNoise(el) {
    var track = el.querySelector('.blaze-track');
    if (!track) return;
    Array.prototype.slice.call(track.children).forEach(function (node) {
      var tag = node.tagName;
      if (tag === 'STYLE' || tag === 'SCRIPT' || tag === 'LINK') el.appendChild(node);
    });
  }

  function create(el) {
    if (!el || el._flexiBlaze || typeof BlazeSlider === 'undefined') return;
    if (!el.querySelector('.blaze-track')) return;
    liftTrackNoise(el);
    var slider;
    try {
      slider = new BlazeSlider(el, config(el));
    } catch (err) {
      return;
    }
    el._flexiBlaze = slider;
    var settle = function () {
      if (!el.isConnected || !el._flexiBlaze) return;
      if (slider.refresh) slider.refresh();
      reveal(el);
      if (!el._flexiScrollbarReady && (el.dataset.pagination || 'dots') === 'scrollbar') {
        setupScrollbar(el, slider);
        el._flexiScrollbarReady = true;
      }
      equalize(el.closest('[data-flexi-equalize]'));
    };
    requestAnimationFrame(function () {
      requestAnimationFrame(settle);
    });
  }

  function slideLimit(el) {
    var max = parseInt(el.getAttribute('data-slide-max'), 10);
    return max > 0 ? max : 900;
  }

  function shouldSlide(el) {
    if (el.getAttribute('data-flexi-slider') === 'always') return true;
    if (el.getAttribute('data-flexi-slider') === 'below-desktop') {
      return window.innerWidth <= slideLimit(el);
    }
    return breakpoint() !== 'desktop';
  }

  function sliderEl(root) {
    if (root.matches && root.matches('[data-flexi-slider]')) return root;
    return root.querySelector('[data-flexi-slider]');
  }

  function reinit(root) {
    var el = sliderEl(root);
    if (!el) {
      equalize(root);
      return;
    }
    destroy(el);
    liftTrackNoise(el);
    if (shouldSlide(el)) {
      create(el);
      el._flexiSliding = true;
    } else {
      el._flexiSliding = false;
      equalize(root);
    }
  }

  function bind(root) {
    if (!root || root._flexiBound) return;
    root._flexiBound = true;
    var timer = null;
    if (window.ResizeObserver) {
      new ResizeObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(function () { equalize(root); }, 200);
      }).observe(root);
    }
    window.addEventListener('resize', function () {
      clearTimeout(root._flexiResizeTimer);
      root._flexiResizeTimer = setTimeout(function () {
        var el = sliderEl(root);
        if (!el) {
          equalize(root);
          return;
        }
        if (el.getAttribute('data-flexi-slider') === 'below-desktop') {
          var sliding = window.innerWidth <= slideLimit(el);
          if (sliding !== !!el._flexiSliding) {
            el._flexiSliding = sliding;
            reinit(root);
            return;
          }
        }
        if (el._flexiBlaze && el._flexiBlaze.refresh) {
          el._flexiBlaze.refresh();
        }
        equalize(root);
      }, 150);
    });
    reinit(root);
  }

  function rootsIn(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var nodes = [];
    if (root.matches && root.matches('[data-flexi-equalize]')) nodes.push(root);
    root.querySelectorAll('[data-flexi-equalize]').forEach(function (node) {
      nodes.push(node);
    });
    return nodes;
  }

  function scan(scope) {
    rootsIn(scope).forEach(function (node) {
      if (!node._flexiBound) bind(node);
    });
  }

  function reload(scope) {
    rootsIn(scope).forEach(function (node) {
      var el = sliderEl(node);
      if (el) destroy(el);
      if (!node._flexiBound) bind(node);
      else reinit(node);
    });
  }

  function start() { scan(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  document.addEventListener('shopify:section:load', function (event) {
    reload(event.target);
  });
  document.addEventListener('shopify:section:reorder', function (event) {
    reload(event.target);
  });
  document.addEventListener('shopify:block:select', function (event) {
    var block = event.target;
    var track = block && block.closest ? block.closest('.blaze-track') : null;
    var sliderRoot = track && track.closest('[data-flexi-slider]');
    var slider = sliderRoot && sliderRoot._flexiBlaze;
    if (!track || !slider) {
      scan(block);
      return;
    }
    var slides = Array.prototype.filter.call(track.children, function (node) {
      return node.nodeType === 1 && node.tagName !== 'STYLE' && node.tagName !== 'SCRIPT';
    });
    var index = -1;
    for (var i = 0; i < slides.length; i++) {
      if (slides[i] === block || slides[i].contains(block)) {
        index = i;
        break;
      }
    }
    if (index < 0) return;
    clearInterval(slider.autoplayTimer);
    var steps = index - (slider.stateIndex || 0);
    if (steps > 0 && slider.next) slider.next(steps);
    else if (steps < 0 && slider.prev) slider.prev(-steps);
  });

  if (window.MutationObserver && document.documentElement) {
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        scan(document);
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
  } catch(e) { console.error(e); }
})();

})();
